import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import BrandSlider from "../Elements/BrandSlider";

var bnrimg = require("./../../images/banner/1.jpg");

const products = [
  {
    id: 1,
    image: require("../../images/cement1.jpg"),
    title: "Premium Cement Solutions",
    description:
      "High-quality cement products from leading brands for all your construction needs. Ensuring durability and strength for residential and commercial projects.",
    category: "Cement",

    icon: "fa fa-cubes",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  {
    id: 2,
    image: require("../../images/steel.webp"),
    title: "Steel & Metal Products",
    description:
      "Superior steel and metal solutions for structural applications. Trusted brands for reliable construction with certified quality standards.",
    category: "Steel",

    icon: "fa fa-industry",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  },
  {
    id: 3,
    image: require("../../images/PVC.jpg"),
    title: "PVC & Plumbing Solutions",
    description:
      "Complete range of PVC pipes and plumbing accessories for residential and commercial projects with long-lasting performance.",
    category: "Plumbing",

    icon: "fa fa-wrench",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  {
    id: 4,
    image: require("../../images/bricks.jpg"),
    title: "Brick & Block",
    description:
      "High-quality bricks manufactured with precision for superior strength and aesthetic appeal in construction projects.",
    category: "Bricks",

    icon: "fa fa-th-large",
    gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
  },
  {
    id: 5,
    image: require("../../images/projects/bitumen.avif"),
    title: "Bitumen & LDO",
    description:
      "Thermo Mechanically Treated steel bars offering superior strength, ductility, and earthquake resistance for modern construction.",
    category: "Bitumen",

    icon: "fa fa-bars",
    gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
  },
  {
    id: 6,
    image: require("../../images/paint.jpeg"),
    title: "Paints & Polishes",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Paint",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 7,
    image: require("../../images/whiteputty.jpg"),
    title: "White Cement & Putty",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Cement",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 8,
    image: require("../../images/projects/Tileadessive.jpg"),
    title: "Tile Adesives",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Adesives",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 9,
    image: require("../../images/watertank.webp"),
    title: "Water Tanks",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Tanks",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 10,
    image: require("../../images/wire.webp"),
    title: "Wires & Cables",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Cables",
    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 11,
    image: require("../../images/TilesFlooring.jpg"),
    title: "Tile & Flooring",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Tiles",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 12,
    image: require("../../images/Plywoodsolutions.jpg"),
    title: "Plywood Solutions",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "Plywood",

    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
  {
    id: 13,
    image: require("../../images/Flyash.webp"),
    title: "Ready Mix Concrete",
    description:
      "Specialized cement formulations for specific applications including rapid setting, white cement, and waterproof varieties.",
    category: "RMC",
    icon: "fa fa-flask",
    gradient: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
  },
];

class Products extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          {/* <Banner
            title="Quality Products for Every Construction Need"
            pagename="Products"
            bgimage={bnrimg}
          /> */}

          {/* PRODUCTS SECTION */}
          <div
            className="section-full mobile-page-padding p-t80 p-b80"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <div className="container">
              {/* TITLE SECTION */}
              <div className="text-center mb-5">
                <h2
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "700",
                    color: "#333",
                    marginBottom: "15px",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                  }}
                >
                  Our <span style={{ color: "#3fa4ca" }}>Product Range</span>
                </h2>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#3fa4ca",
                    margin: "0 auto 20px",
                    borderRadius: "2px",
                  }}
                />
                <p
                  style={{
                    fontSize: "1.1rem",
                    color: "#666",
                    maxWidth: "600px",
                    margin: "0 auto",
                    lineHeight: "1.6",
                    paddingBottom: "30px",
                  }}
                >
                  Discover our comprehensive range of construction materials,
                  carefully selected from industry-leading brands to ensure
                  quality and reliability for your projects.
                </p>
              </div>

              {/* PRODUCTS GRID */}
              <div className="row mb-8">
                {products.map((product, index) => (
                  <div
                    key={product.id}
                    className="col-lg-4 col-md-6 col-sm-12 mb-4 "
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        borderRadius: "15px",
                        overflow: "hidden",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.4s ease",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        border: "1px solid #f0f0f0",
                        marginTop: "30px",
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      {/* Image Section */}
                      <div
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          height: "250px",
                        }}
                      >
                        <img
                          src={product.image}
                          alt={product.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform 0.4s ease",
                          }}
                          onMouseOver={e => {
                            e.target.style.transform = "scale(1.1)";
                          }}
                          onMouseOut={e => {
                            e.target.style.transform = "scale(1)";
                          }}
                        />

                        {/* Category Badge */}
                        <div
                          style={{
                            position: "absolute",
                            top: "15px",
                            left: "15px",
                            backgroundColor: "#3fa4ca",
                            color: "white",
                            padding: "8px 15px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {product.category}
                        </div>

                        {/* Icon Overlay */}
                        {/* <div
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            color: "#3fa4ca",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "18px",
                          }}
                        >
                          <i className={product.icon} />
                        </div> */}

                        {/* Gradient Overlay */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "50%",
                            background:
                              "linear-gradient(transparent, rgba(0,0,0,0.3))",
                          }}
                        />
                      </div>

                      {/* Content Section */}
                      <div
                        style={{
                          padding: "25px",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <h4
                          style={{
                            fontSize: "1.4rem",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "15px",
                            lineHeight: "1.3",
                          }}
                        >
                          {product.title}
                        </h4>

                        {/* Action Buttons */}
                        {/* <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "space-between",
                          }}
                        >
                          <button
                            style={{
                              flex: 1,
                              padding: "12px 20px",
                              backgroundColor: "transparent",
                              border: "2px solid #3fa4ca",
                              color: "#3fa4ca",
                              borderRadius: "25px",
                              fontSize: "14px",
                              fontWeight: "600",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                            onMouseOver={e => {
                              e.target.style.backgroundColor = "#3fa4ca";
                              e.target.style.color = "white";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onMouseOut={e => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#3fa4ca";
                              e.target.style.transform = "translateY(0)";
                            }}
                          >
                            View Details
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Product Categories Navigation */}
          {/* <div
            className="section-full p-t80 p-b80"
            style={{ backgroundColor: "white" }}
          >
            <div className="container">
              <div className="text-center mb-5">
                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "30px",
                  }}
                >
                  Browse by Category
                </h3>
              </div>
              <div className="row">
                {[
                  "Cement",
                  "Steel",
                  "Plumbing",
                  "Bricks",
                  "TMT Steel",
                  "Specialty",
                ].map((category, index) => (
                  <div key={index} className="col-lg-2 col-md-4 col-sm-6 mb-3">
                    <div
                      style={{
                        padding: "20px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                        textAlign: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        border: "2px solid transparent",
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.backgroundColor = "#3fa4ca";
                        e.currentTarget.style.color = "white";
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#3fa4ca";
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                        e.currentTarget.style.color = "#333";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <h5
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          margin: 0,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {category}
                      </h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

          <BrandSlider />
        </div>
        <Footer />

        {/* Custom Responsive Styles */}
        <style>{`
          @media (max-width: 1200px) {
            .container {
              max-width: 95%;
            }
          }

          @media (max-width: 992px) {
            .col-lg-4 {
              margin-bottom: 30px;
            }
            
            .section-full h2 {
              font-size: 2rem !important;
            }
          }

          @media (max-width: 768px) {
            .section-full h2 {
              font-size: 1.8rem !important;
            }
            
            .col-md-6 {
              margin-bottom: 25px;
            }
            
            .section-full p {
              font-size: 16px !important;
              padding: 0 15px;
            }

            .col-lg-2 {
              max-width: 50%;
              flex: 0 0 50%;
            }
          }

          @media (max-width: 576px) {
            .col-sm-6, .col-sm-12 {
              max-width: 100%;
              flex: 0 0 100%;
            }
            
            .section-full h2 {
              font-size: 1.5rem !important;
            }

            .col-lg-2 {
              max-width: 100%;
              flex: 0 0 100%;
            }

            .section-full .container {
              padding-left: 15px;
              padding-right: 15px;
            }
          }

          @media (max-width: 480px) {
            .section-full {
              padding-top: 60px !important;
              padding-bottom: 60px !important;
            }
          }
        `}</style>
      </>
    );
  }
}

export default Products;
